import { useCallback, useRef, useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { hasRealQuestions } from "../utils";

export function useEvaluationWizardState({ accessToken, evalApi }) {
  const { t } = useTranslation("therapist");
  const [wizardState, setWizardState] = useState({ open: false, data: null });
  const editReqIdRef = useRef(0);

  const openCreate = useCallback(() => {
    setWizardState({ open: true, data: null });
  }, []);

  const openEdit = useCallback(
    async (ev) => {
      if (!ev) return;

      // no editamos standardized
      if (ev.type === "standardized") {
        message.info(t("evaluaciones.avisos.estandarNoEditable"));
        return;
      }

      // si no tengo token o id, abro con lo que haya
      if (!accessToken || !ev._id) {
        setWizardState({ open: true, data: ev });
        return;
      }

      // si ya tiene preguntas, no refetch
      if (hasRealQuestions(ev)) {
        setWizardState({ open: true, data: ev });
        return;
      }

      const reqId = ++editReqIdRef.current;

      try {
        const full = await evalApi.getEvaluationById(accessToken, ev._id);
        if (reqId !== editReqIdRef.current) return;
        setWizardState({ open: true, data: full });
      } catch (e) {
        if (reqId !== editReqIdRef.current) return;
        console.error(e);
        message.error(
          e?.message || t("evaluaciones.avisos.errorCargarParaEditar"),
        );
      }
    },
    [accessToken, evalApi, t],
  );

  const closeWizard = useCallback(() => {
    editReqIdRef.current += 1;
    setWizardState({ open: false, data: null });
  }, []);

  return {
    wizardState,
    openCreate,
    openEdit,
    closeWizard,
  };
}
